import { useRef } from 'react';
import { Button, type TestProps } from '@direct-frontend/components';
import { useToggle } from '@direct-frontend/stdlib';
import { Tooltip } from '#shared/ui/Tooltip';
import styles from './PublishButton.module.css';

type PublishButtonProps = {
    name: string;
    isDisabled?: boolean;
    isLoading?: boolean;
    tooltip: string;
    onClick: VoidFunction;
} & TestProps;

export function PublishButton({
    name,
    isDisabled,
    isLoading,
    tooltip,
    onClick,
    'data-testid': dataTestId = 'PublishButton',
}: PublishButtonProps) {
    const ref = useRef<HTMLButtonElement>(null);
    const { value: isTooltipOpen, toggleOff: closeTooltip, toggleOn: openTooltip } = useToggle(false);

    return (
        <>
            <Tooltip
                className={styles.tooltip}
                triggerRef={ref}
                isOpen={Boolean(isDisabled && isTooltipOpen)}
                title={tooltip}
            />
            <Button
                onHoverStart={openTooltip}
                onHoverEnd={closeTooltip}
                ref={ref}
                onClick={onClick}
                data-testid={dataTestId}
                isDisabled={isDisabled}
                isLoading={isLoading}
                color="accent"
                size="m"
            >
                {name}
            </Button>
        </>
    );
}
